module.exports = __webpack_public_path__ + "static/media/0027.02bb7b65.jpg";